( function ( $, undefined ) {
	/**
	 *  fieldGroupManager
	 *
	 *  Generic field group functionality
	 *
	 *  @date	15/12/17
	 *  @since	5.7.0
	 *
	 *  @param	void
	 *  @return	void
	 */

	var fieldGroupManager = new acf.Model( {
		id: 'fieldGroupManager',

		events: {
			'submit #post': 'onSubmit',
			'click a[href="#"]': 'onClick',
			'click .acf-delete-field-group': 'onClickDeleteFieldGroup',
			'blur input#title': 'onBlurValidateTitle',
		},

		filters: {
			find_fields_args: 'filterFindFieldArgs',
			find_fields_selector: 'filterFindFieldsSelector',
		},

		initialize: function () {
			acf.addAction( 'prepare', this.maybeInitNewFieldGroup );
		},

		maybeInitNewFieldGroup: function() {
			let $field_list_wrapper = $(
				'#acf-field-group-fields > .inside > .acf-field-list-wrap.acf-auto-add-field'
			);

			if ( $field_list_wrapper.length ) {
				$( '.acf-headerbar-actions .add-field' ).trigger( 'click' );
				$( '.acf-title-wrap #title' ).trigger( 'focus' );
			}

			// Watch title input
			// if title empty disable submit button
			// if title exists allow submitting form
			let $submitButton = $( '.acf-publish' );
			$( 'input#title' ).on( 'input', function() {
				const titleValue = $(this).val(); 

				if ( ! titleValue ) {
					$submitButton.addClass( 'disabled' );
				} else {
					$submitButton.removeClass( 'disabled' );
					$(this).removeClass( 'acf-input-error' );
				}
			 });
		},

		onSubmit: function ( e, $el ) {
			// vars
			var $title = $( '.acf-title-wrap #title' );

			// empty
			if ( ! $title.val() ) {
				// prevent default
				e.preventDefault();

				// unlock form
				acf.unlockForm( $el );

				// focus
				$title.trigger( 'focus' );
			}
		},

		onClick: function ( e ) {
			e.preventDefault();
		},

		onClickDeleteFieldGroup: function ( e, $el ) {
			e.preventDefault();
			$el.addClass( '-hover' );

			// Add confirmation tooltip.
			acf.newTooltip( {
				confirm: true,
				target: $el,
				context: this,
				text: acf.__( 'Move field group to trash?' ),
				confirm: function () {
					window.location.href = $el.attr( 'href' );
				},
				cancel: function () {
					$el.removeClass( '-hover' );
				},
			} );
		},

		onBlurValidateTitle: function ( e, $el ) {
			if ( ! $el.val() ) {
				$el.addClass( 'acf-input-error' );
				$( '.acf-publish' ).addClass( 'disabled' );
			} else {
				$el.removeClass( 'acf-input-error' );
				$( '.acf-publish' ).removeClass( 'disabled' );
			}
		},

		filterFindFieldArgs: function ( args ) {
			args.visible = true;

			if ( args.parent && ( args.parent.hasClass( 'acf-field-object' ) || args.parent.parents( '.acf-field-object' ).length ) ) {
				args.visible = false;
			}

			return args;
		},

		filterFindFieldsSelector: function ( selector ) {
			return selector + ', .acf-field-acf-field-group-settings-tabs';
		},
	} );

	/**
	 *  screenOptionsManager
	 *
	 *  Screen options functionality
	 *
	 *  @date	15/12/17
	 *  @since	5.7.0
	 *
	 *  @param	void
	 *  @return	void
	 */

	var screenOptionsManager = new acf.Model( {
		id: 'screenOptionsManager',
		wait: 'prepare',

		events: {
			'change #acf-field-key-hide': 'onFieldKeysChange',
			'change [name="screen_columns"]': 'render',
		},

		initialize: function () {
			// vars
			var $div = $( '#adv-settings' );
			var $append = $( '#acf-append-show-on-screen' );

			// append
			$div.find( '.metabox-prefs' ).append( $append.html() );
			$div.find( '.metabox-prefs br' ).remove();

			// clean up
			$append.remove();

			// initialize
			this.$el = $( '#screen-options-wrap' );

			// render
			this.render();
		},

		isFieldKeysChecked: function () {
			return this.$el.find( '#acf-field-key-hide' ).prop( 'checked' );
		},

		getSelectedColumnCount: function () {
			return this.$el
				.find( 'input[name="screen_columns"]:checked' )
				.val();
		},

		onFieldKeysChange: function ( e, $el ) {
			var val = this.isFieldKeysChecked() ? 1 : 0;
			acf.updateUserSetting( 'show_field_keys', val );
			this.render();
		},

		render: function () {
			if ( this.isFieldKeysChecked() ) {
				$( '#acf-field-group-fields' ).addClass( 'show-field-keys' );
			} else {
				$( '#acf-field-group-fields' ).removeClass( 'show-field-keys' );
			}

			if ( this.getSelectedColumnCount() == 1 ) {
				$( 'body' ).removeClass( 'columns-2' );
				$( 'body' ).addClass( 'columns-1' );
			} else {
				$( 'body' ).removeClass( 'columns-1' );
				$( 'body' ).addClass( 'columns-2' );
			}
		},
	} );

	/**
	 *  appendFieldManager
	 *
	 *  Appends fields together
	 *
	 *  @date	15/12/17
	 *  @since	5.7.0
	 *
	 *  @param	void
	 *  @return	void
	 */

	var appendFieldManager = new acf.Model( {
		actions: {
			new_field: 'onNewField',
		},

		onNewField: function ( field ) {
			// bail early if not append
			if ( ! field.has( 'append' ) ) return;

			// vars
			var append = field.get( 'append' );
			var $sibling = field.$el
				.siblings( '[data-name="' + append + '"]' )
				.first();

			// bail early if no sibling
			if ( ! $sibling.length ) return;

			// ul
			var $div = $sibling.children( '.acf-input' );
			var $ul = $div.children( 'ul' );

			// create ul
			if ( ! $ul.length ) {
				$div.wrapInner( '<ul class="acf-hl"><li></li></ul>' );
				$ul = $div.children( 'ul' );
			}

			// li
			var html = field.$( '.acf-input' ).html();
			var $li = $( '<li>' + html + '</li>' );
			$ul.append( $li );
			$ul.attr( 'data-cols', $ul.children().length );

			// clean up
			field.remove();
		},
	} );
} )( jQuery );
